module.exports = fox._r("images/data-fox-editor-type-image.png", __webpack_public_path__ + "images/data-fox-editor-type-image.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/data-fox-editor-type-image.png
// module id = 941
// module chunks = 4